import { apiRequest, toQueryString } from './apiRequest';
import type { ProjectRepositoriesResponse } from '../../types/api/projectRepositories';
import type { Repository } from '../../types/api/repositories';

export const projectRepositoriesAPI = {
  list: async (
    orgId: string,
    streamId: string,
    projectId: string,
    params: Record<string, unknown> = {},
  ) => {
    const qs = toQueryString(params);
    const data = await apiRequest<ProjectRepositoriesResponse>(
      `/api/organisations/${orgId}/streams/${streamId}/projects/${projectId}/repositories${qs}`,
      { method: 'GET' },
    );
    return data.repositories ?? [];
  },
  connect: async (
    orgId: string,
    streamId: string,
    projectId: string,
    {
      repository,
      deploymentBranches,
      qaBranch,
      uatBranch,
    }: {
      repository: string;
      deploymentBranches: string[];
      qaBranch?: string;
      uatBranch?: string;
    },
  ) => {
    const data = await apiRequest<{ repository?: Repository } | Repository>(
      `/api/organisations/${orgId}/streams/${streamId}/projects/${projectId}/repositories/connect`,
      {
        method: 'POST',
        body: JSON.stringify({ repository, deploymentBranches, qaBranch, uatBranch }),
      },
    );
    return ('repository' in data && data.repository ? data.repository : data) as Repository;
  },
  delete: async (orgId: string, streamId: string, projectId: string, repoId: string) => {
    await apiRequest<any>(
      `/api/organisations/${orgId}/streams/${streamId}/projects/${projectId}/repositories/${repoId}`,
      { method: 'DELETE' },
    );
  },
};
